import { isFeatureEnabled } from '@lumapps/features';

import { DIGITAL_ASSISTANT_FEATURE_TOKEN } from '../constants';

export const isDigitalAssistantEnabled = isFeatureEnabled(DIGITAL_ASSISTANT_FEATURE_TOKEN);
